import {
  TransactionSourceDTO,
  TransactionStateDTO,
} from '@/api/trafikportalen';
import { useCallback } from 'react';
import { useIntl } from 'react-intl';

export const useTransactionTranslations = () => {
  const { formatMessage } = useIntl();

  const getSourceTranslation = useCallback(
    ({ source }: { source: string }) => {
      switch (source as TransactionSourceDTO) {
        case TransactionSourceDTO.portal:
          return formatMessage({ defaultMessage: 'Portalen' });
        case TransactionSourceDTO.allpay:
          return formatMessage({ defaultMessage: 'Tjänsteresa i app' });
        case TransactionSourceDTO.walletcard:
          return formatMessage({ defaultMessage: 'Tjänsteresa på kort' });
        case TransactionSourceDTO['alltix-resellers']:
          return formatMessage({ defaultMessage: 'Återförsäljare' });
        case TransactionSourceDTO['alltix-resellers-portal']:
          return formatMessage({
            defaultMessage: 'Självbetjänad återförsäljning',
          });
        default:
          return source;
      }
    },
    [formatMessage],
  );

  const getStateTranslation = useCallback(
    ({ state }: { state: string }) => {
      switch (state as TransactionStateDTO) {
        case TransactionStateDTO.captured:
          return formatMessage({ defaultMessage: 'Betald' });
        case TransactionStateDTO.refunded:
          return formatMessage({ defaultMessage: 'Återbetalning' });
        default:
          return state;
      }
    },
    [formatMessage],
  );

  return {
    getSourceTranslation,
    getStateTranslation,
  };
};
